export const DEFAULT_RATE_VALUE = 9500;
